import React, { lazy } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { useWeb3React } from '@web3-react/core'
import {
  useFetchCollections,
  useFetchLaunchpads,
  useFetchEthUsdPrice,
  useGetNFTInitializationState,
} from 'state/nftMarket/hooks'
import PageLoader from 'components/Loader/PageLoader'
import { NFTMarketInitializationState } from 'state/nftMarket/types'
import { nftsBaseUrl } from './constants'

const Home = lazy(() => import('./Home'))
const NftProfile = lazy(() => import('./Profile'))
const Collection = lazy(() => import('./Collection'))
const Collections = lazy(() => import('./Collections'))
const Launchpad = lazy(() => import('./Launchpad'))
const Launchpads = lazy(() => import('./Launchpads'))
const LaunchpadEdit = lazy(() => import('./LaunchpadEdit'))
const Mypage = lazy(() => import('./Mypage'))

const Market = () => {
  const { account } = useWeb3React()
  const initializationState = useGetNFTInitializationState()

  useFetchCollections()
  useFetchLaunchpads()
  useFetchEthUsdPrice()

  const params = new URLSearchParams(window.location.search.substring(1))
  const ref = params.get('ref')
  if (ref) {
    window.localStorage.setItem('nftReferer', ref)
  }

  if (initializationState !== NFTMarketInitializationState.INITIALIZED) {
    return <PageLoader />
  }

  return (
    <>
      <Route exact path={nftsBaseUrl}>
        <Home />
      </Route>
      <Route exact path={`${nftsBaseUrl}/createnft`}>
        <Redirect to={`${nftsBaseUrl}/mypage/nfts/create`} />
      </Route>
      <Route exact path={`${nftsBaseUrl}/createpad`}>
        <Redirect to={`${nftsBaseUrl}/mypage/pads/create`} />
      </Route>
      <Route exact path={`${nftsBaseUrl}/createcollection`}>
        <Redirect to={`${nftsBaseUrl}/mypage/collections/create`} />
      </Route>
      <Route exact path={`${nftsBaseUrl}/createfeemanager`}>
        <Redirect to={`${nftsBaseUrl}/mypage/feemanagers/create`} />
      </Route>
      <Route path={`${nftsBaseUrl}/mypage`}>
        <Mypage />
      </Route>
      <Route exact path={`${nftsBaseUrl}/collections`}>
        <Collections />
      </Route>
      <Route path={`${nftsBaseUrl}/collections/:collectionAddress`}>
        <Collection />
      </Route>
      <Route exact path={`${nftsBaseUrl}/launchpads`}>
        <Launchpads />
      </Route>
      <Route exact path={`${nftsBaseUrl}/launchpads/edit/:collectionAddress`}>
        <LaunchpadEdit />
      </Route>
      <Route exact path={`${nftsBaseUrl}/launchpads/:collectionAddress`}>
        <Launchpad />
      </Route>
      <Route path={`${nftsBaseUrl}/profile/:accountAddress?`}>
        <NftProfile />
      </Route>
      <Route exact path={`${nftsBaseUrl}/profile`}>
        <Redirect to={`${nftsBaseUrl}/profile/${account?.toLowerCase() || ''}`} />
      </Route>
    </>
  )
}

export default Market
